import type { PensionFeatureConfig } from '../types/PensionFeatureConfig';

export const pension: PensionFeatureConfig = {
    defaultRoute: 'overview',
    relyOnWebAPIAlias: true,
    overview: {
        visible: true,
        highlights: {
            showOwnerContribution: false,
            showContractEndDate: false,
        },
        highlightedDetails: {
            showAdhesionAct: false,
            showContractNumber: true,
        },
        learnMore: {
            visible: false,
            savingsUrl: null,
            supplementaryUrl: null,
            phone: null,
            email: null,
        },
    },
    transactions: {
        visible: false,
    },
    funds: {
        visible: true,
    },
};
